module.exports = "<action-list-item ng-if=restrictUi.asInternalFeature() contents=\"{\n    iconClass: 'fa-line-chart',\n    ordinal: $ctrl.contents.ordinal,\n    title: 'Sales &amp; expense projections',\n    description: 'These are vital to get a sensible idea of what the end-of-year results actually will be.',\n    actions: [\n    ],\n}\"></action-list-item> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/action-list-items/contents/sales-and-expense-projections.html
// module id = 1761
// module chunks = 86